import USItemsMap from 'components/generics/maps/USItemsMap';
import LendMapPropertyCard from 'pages/lend/components/LandaFinancingMap/LendMapPropertyCard';
import { DebtType } from 'types/debt-types';
import classes from './index.module.scss';

interface Props {
  debt: DebtType;
}

const LandaFinancingMap = ({ debt }: Props) => {
  return (
    <USItemsMap
      items={debt?.borrowerProperties}
      coordinatesGetter={(borrower) => borrower?.property?.coordinates}
      className={classes.container}
      cardRenderer={(borrowerProperty) => (
        <LendMapPropertyCard borrowerProperty={borrowerProperty} />
      )}
    />
  );
};

export default LandaFinancingMap;
